<glxy-select-input
  dense
  required="true"
  [formControl]="isEmptyFormControl"
  [options]="isEmptyOptions"
></glxy-select-input>
